import { installDetection } from './detect';
import { fetchLicense } from './license';
import { mountLauncher } from './panel';

//
// Check that a ?mapvideo URL parameter is present. Only in this case
// should the embedded code activate.
//
function shouldActivate(): boolean {
  return new URLSearchParams(window.location.search).has('mapvideo');
}

function boot(): void {
  // If we are already running, do nothing.
  const w = window as unknown as { __mve_booted?: boolean };
  if (w.__mve_booted) return;
  w.__mve_booted = true;

  // Without ?mapvideo the recorder is dormant: no detection, no DOM
  // mutations, no global patches. Exit early so a customer's normal
  // production traffic pays literally nothing for having our script
  // tag in <head>.
  if (!shouldActivate()) return;

  // Activated. Install every detection strategy and mount the launcher
  // as soon as the DOM is ready to take it. License fetch runs in
  // parallel with detection so we don't serialise two network waits.
  installDetection();
  const licensePromise = fetchLicense();

  // Mount the panel when the DOM is ready.
  const mount = (): void => {
    void licensePromise.then((license) => mountLauncher(license));
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }
}

//
// Kick off the program.
//
boot();
